namespace TabAurous.HR {
    export interface LeaveTypeForm {
        LeaveTypeCode: Serenity.StringEditor;
        MaxLeavesAllowed: Serenity.IntegerEditor;
        ApplicableAfter: Serenity.IntegerEditor;
        MaxContinuosDays: Serenity.IntegerEditor;
        AllowEncashment: Serenity.BooleanEditor;
        MaxEncashmentDays: Serenity.IntegerEditor;
        EncashmentComponentId: Serenity.LookupEditor;
        IsCarryForward: Serenity.BooleanEditor;
        IsLeaveWithoutPay: Serenity.BooleanEditor;
        IsOptional: Serenity.BooleanEditor;
        AllowNegativeBalance: Serenity.BooleanEditor;
        Includeholidayswithinleavesasleaves: Serenity.BooleanEditor;
        IsCompensatory: Serenity.BooleanEditor;
        IsPartiallyPaidLeaves: Serenity.BooleanEditor;
        FractionofDailySalaryPerLeave: Serenity.DecimalEditor;
    }

    export class LeaveTypeForm extends Serenity.PrefixedContext {
        static formKey = 'HR.LeaveType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LeaveTypeForm.init)  {
                LeaveTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(LeaveTypeForm, [
                    'LeaveTypeCode', w0,
                    'MaxLeavesAllowed', w1,
                    'ApplicableAfter', w1,
                    'MaxContinuosDays', w1,
                    'AllowEncashment', w2,
                    'MaxEncashmentDays', w1,
                    'EncashmentComponentId', w3,
                    'IsCarryForward', w2,
                    'IsLeaveWithoutPay', w2,
                    'IsOptional', w2,
                    'AllowNegativeBalance', w2,
                    'Includeholidayswithinleavesasleaves', w2,
                    'IsCompensatory', w2,
                    'IsPartiallyPaidLeaves', w2,
                    'FractionofDailySalaryPerLeave', w4
                ]);
            }
        }
    }
}
